const PRONOUN_OPTIONS = [
  'she/her/hers',
  'he/him/his',
  'they/them/theirs',
  'other',
];

export default PRONOUN_OPTIONS;
